import React, { useState } from 'react'
import { encrypt } from '@mkmp/core'
import { login, logout, getKey } from '@/features/auth'

interface AuthContextType {
  isAuthenticated: boolean
  userLogin: (account: string, password: string, captchaKey: string, captcha: string) => Promise<any>
  userLogout: () => void
}

export const AuthContext = React.createContext<AuthContextType>(null!)

/**
 * 授权
 * @param param0
 * @returns
 */
export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(!!window.localStorage.getItem('token'))

  /**
   * 用户登录
   * @param account 登录账号
   * @param password
   * @param key
   * @param code
   * @param callback
   * @returns
   */
  const userLogin = async (account: string, password: string, captchaKey: string, captcha: string) => {
    const keyData = await getKey()
    const encryotPassword = encrypt(password, keyData.publicKey)

    const { token } = await login(account, encryotPassword.toString(), keyData.randomCode, captchaKey, captcha)
    setIsAuthenticated(true)
    window.localStorage.setItem('token', token)
    return true
  }

  /**
   * 用户登出
   * @returns
   */
  const userLogout = () => {
    return new Promise((resolve, reject) => {
      logout()
        .then((res: any) => {
          setIsAuthenticated(false)
          window.localStorage.removeItem('token')
          resolve(true)
        })
        .catch((e: any) => {
          reject(false)
        })
    })
  }

  return <AuthContext.Provider value={{ isAuthenticated, userLogin, userLogout }}>{children}</AuthContext.Provider>
}
